import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import {
  getAuth,
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  signOut,
  sendEmailVerification
} from "firebase/auth";
import {
  getFirestore,
  doc,
  setDoc,
  serverTimestamp // 🔹 Swapped out local computer time for reliable server time
} from "firebase/firestore";

// ✅ Firebase config
const firebaseConfig = { 
  apiKey: "AIzaSyB3JbzF-jwKW9evxugOJ9yCMZ_BefkSZII",
  authDomain: "toefl-vocabulary-booster.firebaseapp.com",
  projectId: "toefl-vocabulary-booster",
  storageBucket: "toefl-vocabulary-booster.appspot.com",
  messagingSenderId: "20032753932",
  appId: "1:20032753932:web:802aee986dacdff2ca7929",
  measurementId: "G-SDJHC7PXR0"
};

// ✅ Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);
const analytics = getAnalytics(app);

// ✅ Sign up user with 7-day trial and Bot Mitigation
const signUp = async (email, password, name) => {
  try {
    // 🔹 BOT DEFENSE: Check for excessive dots in Gmail
    const emailLower = email.toLowerCase();
    if (emailLower.endsWith('@gmail.com')) {
      const username = emailLower.split('@')[0];
      const dotCount = (username.match(/\./g) || []).length;
      
      // If a username has more than 3 dots, it's highly likely a bot
      if (dotCount > 3) {
        throw new Error("Registration rejected. Invalid email format.");
      }
    }

    const userCredential = await createUserWithEmailAndPassword(auth, email, password);
    const user = userCredential.user;

    const trialEnds = new Date();
    trialEnds.setDate(trialEnds.getDate() + 7);

    // ✅ Send verification (non-blocking)
    try {
      await sendEmailVerification(user);
      console.log("✅ Email verification sent");
    } catch (err) {
      console.warn("⚠️ Email verification warning:", err.message);
    }

    // ✅ 🔁 Wait a tick before writing to Firestore
    await new Promise((resolve) => setTimeout(resolve, 300));

    // ✅ Write user doc
    await setDoc(doc(db, 'users', user.uid), {
      name: name,
      email: email,
      role: 'student',
      createdAt: serverTimestamp(),  // 🔹 Use serverTimestamp so user local clocks don't warp your analytics
      lastLoginAt: serverTimestamp(), // 🔹 Initializes their first tracking timestamp automatically!
      plan: 'trial',
      unlocked: true,
      trialEnds: trialEnds,
      isPaid: false,
      emailVerified: user.emailVerified ?? false,
    }, { merge: true });

    return userCredential;
  } catch (error) {
    console.error("❌ Error signing up:", error.message);
    throw error;
  }
};

// ✅ Sign in existing user
const signIn = async (email, password) => {
  try {
    const userCredential = await signInWithEmailAndPassword(auth, email, password);
    return userCredential;
  } catch (error) {
    console.error("❌ Error signing in:", error.message);
    throw error;
  }
};

// ✅ Sign out
const logout = () => signOut(auth);

// ✅ Export
export {
  auth,
  db,
  signUp,
  signIn,
  logout,
  app,
  analytics,
};